import connectToStores from 'alt-utils/lib/connectToStores';

export default connectToStores;
